import { TabConfig, TabKey } from '../CustomersV2.types';

export const TAB_CONFIGS: Record<TabKey, TabConfig> = {
  onboarding: {
    key: 'onboarding',
    path: 'onboarding',
    label: 'In progress',
    view: 'onboarding',
    description:
      "Track your customers' progress through the iwocaPay onboarding journey.",
    columns: [
      {
        id: 'date',
        header: 'Date of application',
        sortKey: 'earliest_interacted_date',
      },
      { id: 'company', header: 'Company', sortKey: 'buyer_name' },
      { id: 'approvedLimit', header: 'Approved limit' },
      {
        id: 'onboardingProgress',
        header: 'Onboarding progress',
        infoModal: true,
        // Two groups of step bars plus their labels need room the even split
        // Orion gives every column does not leave them. The remaining columns
        // divide what is left, landing them on a fifth of the table each.
        width: 'basis-[37.5%] shrink-0',
      },
    ],
    pills: [
      { value: 'business_details', label: 'Business details', icon: 'file' },
      { value: 'security', label: 'Security checks', icon: 'shield' },
    ],
    filterParam: 'application_stage',
    defaultSort: '-earliest_interacted_date',
    settings: [],
  },
  spendingLimit: {
    key: 'spendingLimit',
    path: 'spending-limit',
    label: 'Decision complete',
    view: 'spending_limit',
    description:
      'See which customers have an approved limit and how much they have to spend.',
    columns: [
      {
        id: 'date',
        header: 'Date of application',
        sortKey: 'earliest_interacted_date',
      },
      { id: 'company', header: 'Company', sortKey: 'buyer_name' },
      // Both cells hold composed content — an amount stacked over its payment
      // reference, and an amount beside an expiry note — so they hold a fixed
      // width whether or not latest payment is revealed. Date, company and
      // status divide what these two leave, equally.
      {
        id: 'latestPayment',
        header: 'Latest payment',
        revealedBy: 'latestPayment',
        width: 'basis-[190px] shrink-0',
      },
      {
        id: 'status',
        header: 'Status',
        infoModal: true,
      },
      { id: 'toSpend', header: 'To spend', width: 'basis-[330px] shrink-0' },
    ],
    pills: [
      { value: 'offer_approved', label: 'Ready to use', icon: 'pound' },
      {
        value: 'last_approved_offer',
        label: 'Time to refresh',
        icon: 'refresh',
      },
      {
        value: 'declined_offer',
        label: 'Declined',
        icon: 'declined',
        revealedBy: 'declined',
      },
    ],
    filterParam: 'spending_limit_status',
    defaultSort: '-earliest_interacted_date',
    settings: [
      { key: 'latestPayment', label: 'View latest payment' },
      { key: 'declined', label: 'View declined customers' },
    ],
  },
};

export const TAB_CONFIG_LIST: TabConfig[] = Object.values(TAB_CONFIGS);

export const DEFAULT_TAB_PATH = TAB_CONFIGS.onboarding.path;

export function getTabConfigByPath(path: string): TabConfig | undefined {
  return TAB_CONFIG_LIST.find((tab) => tab.path === path);
}
